module.exports = __webpack_public_path__ + "img/7_71.c04ddd34.png";